import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  private readonly baseUrl = environment.baseUrl;
  private readonly routePrefix = 'api/v1/admin';

  constructor(private http: HttpClient ,
    
    private snackBar: MatSnackBar) { }


    getRequestList( startPage: number, pageSize: number, filter?: number): Observable<any> {
      return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/user/requests/${filter}/?startPage=${startPage}&pageSize=${pageSize}`
      )
      .pipe(map((res: any) => res.data));
    }

    getResponseList( id: number, filter?: number): Observable<any> {
      return this.http
      .get(
        `${this.baseUrl}/${this.routePrefix}/user/request/${id}/response/${filter}`
      )
      .pipe(map((res: any) => res.data));
    }
}
